import React, { useState, useEffect } from "react";
import moment from "moment";
import Profile from "../images/profile.png";
import ProfileInner from "../images/profileInner.png";
import { useNavigate } from "react-router-dom";
import DataService from "../services/data.service";
import { toast } from "react-toastify";

const TopBar = ({ title, menu, subMenu, toggleSidebar }) => {
  const navigate = useNavigate();
  const [time, setTime] = useState(moment());
  const [profileOpen, setProfileOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [notPopup, setNotPopup] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(moment());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    getNotifications();
    const notiInterval = setInterval(getNotifications, 60000); // Check every minute
    return () => clearInterval(notiInterval);
  }, []);

  const getNotifications = () => {
    DataService.getNotifications()
      .then((res) => {
        setNotifications(res?.data?.data || []);
      })
      .catch((err) => {
        console.error("Failed to fetch notifications", err);
      });
  };

  const markAsRead = (notif) => {
    if (notif.is_read) {
      if (notif.contactId) navigate("/contact-form"); // Or specific view if available
      return;
    }

    DataService.updateNotification(notif._id, { is_read: true })
      .then(() => {
        getNotifications();
        if (notif.contactId) navigate("/contact-form");
      })
      .catch((err) => {
        toast.error("Failed to update notification");
      })
      .finally(() => {
      });
  };
  const logMeOut = () => {
    localStorage.removeItem("tUser");
    localStorage.removeItem("tUserId");
    localStorage.removeItem("tToken");
    navigate("/");
  };

  return (
    <>
      <div className="topBarSec">
        <div className="row align-items-center">
          <div className="col-sm-5 d-flex align-items-center">
            <i className="fas fa-bars me-2" onClick={toggleSidebar} />
            <div className="breadcrumbSec">
              <span>
                <i className="fas fa-home" /> Home
              </span>
              <span>{menu ? " / " + menu : ""}</span>
              <span>{subMenu ? " / " + subMenu : ""}</span>
              <span>{title ? " / " + title : ""}</span>
            </div>
          </div>
          <div className="col-sm-4 text-center">
            <span className="runningTime">
              <i className="far fa-clock" />{" "}
              {time.format("MMM D, YYYY, h:mm:ss A")}
            </span>
          </div>
          <div className="col-sm-3">
            <div className="userSec">
              <div className="notiBell me-3" style={{ cursor: "pointer" }} onClick={() => setNotPopup(!notPopup)}>
                <i className="fas fa-bell" />
                {notifications.filter(n => !n.is_read).length > 0 && (
                  <span className="notiBubble">
                    {notifications.filter(n => !n.is_read).length}
                  </span>
                )}
                {notPopup && (
                  <div className="notBody">
                    <div className="notHeader">
                      <h6 className="mb-0">Notifications</h6>
                    </div>
                    <div className="notScroll">
                      {notifications.length > 0 ? (
                        notifications.map((notif, index) => (
                          <div
                            key={index}
                            className={`notInner ${!notif.is_read ? 'unread' : ''}`}
                            onClick={(e) => {
                              e.stopPropagation();
                              markAsRead(notif);
                            }}
                          >
                            <h6>{notif.subject || "No Subject"}</h6>
                            <p className="mb-1">{notif.body}</p>
                            <span>
                              <i className="far fa-clock me-1" />
                              {moment(notif.createdAt).fromNow()}
                            </span>
                          </div>
                        ))
                      ) : (
                        <div className="p-3 text-center">
                          <p className="mb-0">No New Notifications</p>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
              <div
                className="userButton"
                onClick={() => setProfileOpen(!profileOpen)}
              >
                <img src={Profile} alt="profile" className="profile_image" />
                <span>admin@123</span>
                <i className="fas fa-chevron-down" />
                {profileOpen && (
                  <div className="profileOpen">
                    <div className="row align-items-start mb-1">
                      <div className="col-sm-3 col-3">
                        <img
                          src={ProfileInner}
                          alt="profileInner"
                          className="profileInner"
                        />
                      </div>
                      <div className="col-sm-9 col-9">
                        <h5 className="colorHeadFive">
                          <strong>admin@123</strong>
                        </h5>
                        <p className="mb-1">Admin</p>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-6">
                      </div>
                      <div className="col-6">
                        <button
                          className="btn btn-primary w-100"
                          onClick={logMeOut}
                        >
                          Logout
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TopBar;
